import React from "react";

const CreativeCommons = () => {
  return (
    <div>
      <p className="detail-text paragraph">
        Making original music available to creators and storytellers is an
        important part of our goal as a studio. We work with lots of artists to
        make their projects happen using our free non-commercial license. It’s
        how we got started in radio and audio production and it’s something we
        want to pass on to others.
      </p>
      <p className="detail-text paragraph">
        <p className="paragraph-title">What counts as non-commercial?</p>
        For more detailed information you can visit{" "}
        <a href="creativecommons.org" target="_blank">
          creativecommons.org
        </a>
        , but below are a few guidelines that we offer. Your work is likely
        considered non-commercial if it meets all of the following criteria:
      </p>
      <p className="paragraph detail-text">
        <ul>
          <li>- The work does not promote a product or service</li>
          <li>- It is not branded content</li>
          <li>- It is not sponsored and does not include advertisements</li>
          <li>
            - No one is producing it as a part of their paid job duties
          </li>
          
          <li>- You have not paid any other contributor to the project</li>
          <li>- You have not been paid for your work on the project</li>
          <li>
            - You will not monetize the work via YouTube or any other outlet
          </li>
          <li> - It will not be published behind a paywall</li>
        </ul>
      </p>
      <p className="detail-text paragraph">
        <p className="paragraph-title">How do I give credit?</p>
        If you’re using the music under our non-commercial license then you are
        required to give credit, don’t worry it’s really simple! You can use the
        following format:
        <p
          style={{ marginLeft: "32px", marginTop: 32 }}
          className="paragraph-title"
        >
          Track Name by Blue Dot Sessions (www.sessions.blue).
        </p>
      </p>
      <p className="detail-text paragraph">
        <p className="detail-text">
          If you are making media that has credits as part of it, like at the
          end of a short film or radio show, please include this text or say
          something like “Music in this episode by Blue Dot Sessions”. If it’s
          just a short film without credits then it can be included in the video
          description or other text wherever the media is embedded.
        </p>
        <p className="paragraph detail-text">
          <p className="paragraph-title">What music can I use? </p>
          All of our songs in .mp3 format are licensed Creative Commons,
          although the .wav files, stems, variations and additional content are only
          available to license holders or blanket license subscribers.
        </p>
      </p>
      <p className="paragraph detail-text">
        <p className="paragraph-title">
          What if my project starts making me money later?
        </p>
        You can always come back and purchase a license later if your situation
        changes or if you find ways of monetizing your work.
      </p>
    </div>
  );
};

export default CreativeCommons;
